import { RESET_DATA, SET_DATA } from 'modules/MediaPlanner/types'

const initialState = {}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA:
      return { ...state, ...action.payload }
    case RESET_DATA:
      return initialState

    default:
      return state
  }
}

export default reducer
